var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Modal, Button, TextContent, Text, TextVariants, DataListItem, DataList, DataListItemRow, DataListCheck, DataListCell, DataListItemCells, Split, SplitItem, ButtonVariant, ModalVariant } from '@patternfly/react-core';
;
const ColumnManagementModal = (_a) => {
    var { title = 'Manage columns', description = 'Selected categories will be displayed in the table.', isOpen = false, onClose = () => undefined, appliedColumns, applyColumns, ouiaId = 'ColumnManagementModal' } = _a, props = __rest(_a, ["title", "description", "isOpen", "onClose", "appliedColumns", "applyColumns", "ouiaId"]);
    const [currentColumns, setCurrentColumns] = React.useState(appliedColumns.map(column => { var _a; return (Object.assign(Object.assign({}, column), { isShown: (_a = column.isShown) !== null && _a !== void 0 ? _a : column.isShownByDefault })); }));
    const handleChange = index => {
        const newColumns = [...currentColumns];
        const changedColumn = Object.assign({}, newColumns[index]);
        changedColumn.isShown = !changedColumn.isShown;
        newColumns[index] = changedColumn;
        setCurrentColumns(newColumns);
    };
    const selectAll = () => {
        let newColumns = [...currentColumns];
        newColumns = newColumns.map(column => (Object.assign(Object.assign({}, column), { isShown: true })));
        setCurrentColumns(newColumns);
    };
    const resetToDefault = () => {
        setCurrentColumns(currentColumns.map(column => { var _a; return (Object.assign(Object.assign({}, column), { isShown: (_a = column.isShownByDefault) !== null && _a !== void 0 ? _a : false })); }));
    };
    const handleSave = event => {
        applyColumns(currentColumns);
        onClose(event);
    };
    const handleCancel = event => {
        setCurrentColumns(appliedColumns.map(column => { var _a; return (Object.assign(Object.assign({}, column), { isShown: (_a = column.isShown) !== null && _a !== void 0 ? _a : column.isShownByDefault })); }));
        onClose(event);
    };
    return (React.createElement(Modal, Object.assign({ title: title, onClose: onClose, isOpen: isOpen, variant: ModalVariant.small, description: React.createElement(TextContent, null,
            React.createElement(Text, { component: TextVariants.p }, description),
            React.createElement(Split, { hasGutter: true },
                React.createElement(SplitItem, null,
                    React.createElement(Button, { isInline: true, onClick: selectAll, variant: ButtonVariant.link, ouiaId: `${ouiaId}-selectAll-button` }, "Select all")),
                React.createElement(SplitItem, null,
                    React.createElement(Button, { isInline: true, onClick: resetToDefault, variant: ButtonVariant.link, ouiaId: `${ouiaId}-reset-button` }, "Reset to default")))), actions: [
            React.createElement(Button, { key: "save", variant: ButtonVariant.primary, onClick: handleSave, ouiaId: `${ouiaId}-save-button` }, "Save"),
            React.createElement(Button, { key: "cancel", variant: ButtonVariant.link, onClick: handleCancel, ouiaId: `${ouiaId}-cancel-button` }, "Cancel")
        ], ouiaId: ouiaId }, props),
        React.createElement(DataList, { "aria-label": "Selected columns", isCompact: true, "data-ouia-component-id": `${ouiaId}-column-list` }, currentColumns.map((column, index) => React.createElement(DataListItem, { key: column.key },
            React.createElement(DataListItemRow, null,
                React.createElement(DataListCheck, { checked: column.isShown, onChange: () => handleChange(index), isDisabled: column.isUntoggleable, "aria-labelledby": `${ouiaId}-column${index}-label`, "data-ouia-component-id": `${ouiaId}-column${index}-checkbox`, id: `${ouiaId}-column${index}-checkbox` }),
                React.createElement(DataListItemCells, { dataListCells: [
                        React.createElement(DataListCell, { key: column.key, "data-ouia-component-id": `${ouiaId}-column${index}-label` },
                            React.createElement("label", { htmlFor: `${ouiaId}-column${index}-checkbox`, id: `${ouiaId}-column${index}-label` }, column.title))
                    ] })))))));
};
export default ColumnManagementModal;
